webpackJsonp([10,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(215);
	module.exports = __webpack_require__(214);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      apiPath: '/apiPath',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    devx: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://dev.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
	      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      aihuazhuUrl: 'https://www.aihuazhu.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (false) {
	  config.scheme = 'test';
	} else if (false) {
	  config.scheme = 'integrate';
	} else if (true) {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ },

/***/ 2:
/***/ function(module, exports) {

	var language = 'zh-CN';
	if (window.location.search.indexOf('locale=USA') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=en') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=YH') > -1) {
	  language = 'YH';
	  localStorage.setItem('language', language);
	} else {
	  localStorage.setItem('language', language);
	}
	
	module.exports = { language: language };

/***/ },

/***/ 3:
/***/ function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'pc' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ },

/***/ 4:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 5:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 214:
/***/ function(module, exports, __webpack_require__) {

	
	
	'use strict';
	// var languageType = require('./languageCommon.js')
	
	__webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	__webpack_require__(237);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(3);
	// if(window.location.search.indexOf('lang=En')>-1){
	//     language='USA';
	//     localStorage.setItem('language','USA')
	// }
	if (language == 'zh-CN') {
	    //如果是英文进入该页面，重定向到中文首页
	    window.location.href = '/index.html?locale=zh-CN';
	    $('body').removeClass('en');
	} else {
	    $('body').addClass('en');
	}
	
	// debugger
	if (language != "USA" && language != "JP") {
	
	    $('.column_slider3_Arula').hide();
	}
	$('.commonHomePage').addClass('select');
	// var $ = require('jquery');
	var Config = __webpack_require__(1);
	var url_prefix = Config.env[Config.scheme].prefix;
	$("img").on('dragstart', function () {
	    return false;
	});
	
	var sliderRowStep = 0;
	var $oImgs = $('.swiper_row .slider');
	function autoMove() {
	    sliderRowStep++;
	    sliderRowStep > 3 ? sliderRowStep = 0 : null; //当显示最后一张，下一次让outer.step变为0
	    $oImgs.eq(sliderRowStep).fadeIn(2500).siblings().fadeOut(2500);
	}
	setInterval(autoMove, 4000);
	$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
	    $('.reservationCode').fadeOut(300);
	    $('.reservation').css('opacity', 1);
	});
	// $('.reservation').on('click',function () {
	//     // $('.reservationCode').fadeIn(300);
	//     // $('.reservation').css('opacity',0);
	// });
	setInterval(function () {
	    $('.bottomArrow').animate({ bottom: '40px' }, 500, 'linear', function () {
	        $('.bottomArrow').animate({ bottom: '20px' }, 500, 'linear', function () {});
	    });
	}, 1000);
	// $('body').click(function (e) {
	//     if(e.target.className=='brand'){
	//         $('.aboutLv').slideUp();
	//         return;
	//     }
	//     if(e.target.className=='about'){
	//         $('.choiceBrand').slideUp();
	//         return;
	//     }
	//     $('.aboutLv').slideUp();
	//     $('.choiceBrand').slideUp();
	// });
	
	// $('.brand').on('click',function () {
	//     $('.choiceBrand').slideDown();
	// });
	// $('.about').on('click',function () {
	//     $('.aboutLv').slideDown();
	// });
	$(".about1").on('mouseover', function () {
	    $(".aboutLv").show();
	});
	$(".about1").on('mouseout', function () {
	    $(".aboutLv").hide();
	});
	$(".brand1").on('mouseover', function () {
	    $(".choiceBrand").show();
	}).on('mouseout', function () {
	    $(".choiceBrand").hide();
	});
	$('.language').on('mouseover', function () {
	    $(".choicelanguage").show();
	}).on('mouseout', function () {
	    $(".choicelanguage").hide();
	});
	$('.choicelanguage a').eq(0).on('click', function () {
	    console.log(window.location);
	    window.location.href = window.location.origin + window.location.pathname + '?locale=zh-CN';
	    localStorage.setItem('language', 'zh-CN');
	    // window.location.href='/index.html';
	});
	$('.choicelanguage a').eq(1).on('click', function () {
	    localStorage.setItem('language', 'USA');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=USA';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(2).on('click', function () {
	    localStorage.setItem('language', 'JP');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=JP';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(3).on('click', function () {
	    localStorage.setItem('language', 'KO');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=KO';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(4).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=TH';
	    //window.location.reload();
	});
	$('.choicelanguage a').eq(5).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=YH';
	    //window.location.reload();
	});
	$('.column_slider').css({ height: document.documentElement.clientHeight });
	var height = document.documentElement.clientHeight;
	var width = document.documentElement.clientWidth;
	
	if (width > 1200) {
	    $('.column_slider6_ten').css({ marginRight: '10px' });
	    $('.column_slider6_seven').css({ marginRight: 0 });
	    $('.column_slider6_eight').css({ width: '1110px' });
	} else {
	    $('.column_slider6_ten').css({ marginRight: '5px' });
	    $('.column_slider6_seven').css({ marginRight: 0 });
	    $('.column_slider6_eight').css({ width: '1080px' });
	}
	$('.shape-wrap').css({ height: height - 80 });
	$('.column_slider4_container').css({
	    height: height - 80
	});
	$('.column_slider5_container').css({
	    height: height
	});
	$('.column_slider6_container').css({
	    height: height - 80
	});
	$('.submitInfo_tips').css({
	    width: width,
	    height: height
	});
	$('.column_slider2_container').css({
	    height: height
	});
	$(window).resize(function () {
	    //当浏览器大小变化时
	    $('.column_slider').css({ height: document.documentElement.clientHeight });
	    $('.swiper_row').css({ height: document.documentElement.clientHeight });
	    height = document.documentElement.clientHeight;
	    width = document.documentElement.clientWidth;
	    $container.css({ top: -containerStep * height });
	    $('.column_slider4_container').css({
	        height: height - 80
	    });
	    $('.column_slider5_container').css({
	        height: height
	    });
	    $('.column_slider6_container').css({
	        height: height
	    });
	    $('.column_slider2_container').css({
	        height: height
	    });
	    $('.submitInfo_tips').css({
	        width: width,
	        height: height
	    });
	    $('.shape-wrap').css({ height: height });
	    if (width > 1200) {
	        $('.column_slider6_ten').css({ marginRight: '10px' });
	        $('.column_slider6_seven').css({ marginRight: 0 });
	
	        $('.column_slider6_eight').css({ width: '1110px' });
	    } else {
	        $('.column_slider6_ten').css({ marginRight: '5px' });
	        $('.column_slider6_seven').css({ marginRight: 0 });
	        $('.column_slider6_eight').css({ width: '1080px' });
	    }
	});
	var $container = $('.container');
	var containerStep = 0;
	
	function move(n, b) {
	    containerStep++;
	    n != undefined ? containerStep = n : null;
	    $(".swiper_title1").removeClass("swiper_title1");
	    $(".column_slider5_smallImg div").removeClass("column_slider5_smallImg111");
	    $(".column_slider6_ten").removeClass("column_slider6_ten1");
	    $(".img").removeClass("img");
	    if (containerStep == 8) {
	        $container.css('top', 0);
	        containerStep = 1;
	    }
	    if (containerStep < 0) {
	        $container.css('top', -7 * height + 'px');
	        containerStep = 6;
	    }
	    $container.animate({ top: -containerStep * height }, 1500, 'easeInQuart', function () {
	        if (parseInt($container.css('top')) == 0 || parseFloat($container.css('top')) == parseInt(-7 * height)) {
	            $(".swiper_title").addClass("swiper_title1");
	            $(".swiper_more").addClass("swiper_title1");
	            $('.banner').removeClass('banner1');
	            $('.logo').removeClass('logo2').addClass('logo1');
	            $('.reservation').css('color', 'white');
	            $('.arrow').css({ borderRightColor: 'rgba(255,255,255,0.5)', borderBottomColor: 'rgba(255,255,255,0.5)' });
	            $('.header_nav').removeClass('header_nav1');
	        } else {
	            $('.banner').addClass('banner1');
	            $('.logo').removeClass('logo1').addClass('logo2');
	            // $('.header_nav li a,.header_nav li').css('color','#2A376E');
	            // $('.header_nav .select').css('borderColor','#2A376E');
	            $('.reservation').css('color', 'white');
	            $('.arrow').css({ borderRightColor: 'black', borderBottomColor: 'black' });
	            $('.header_nav').addClass('header_nav1');
	            if (parseInt($container.css('top')) == -height) {
	                // navigate();
	                $(".column_slider5_container_title").addClass("swiper_title1");
	                $(".column_slider5_container_detail").addClass("swiper_title1");
	                $(".column_slider5_smallImg div").addClass("swiper_title1");
	            }
	            if (parseInt($container.css('top')) == -height * 2) {
	                $(".column_slider4_title").addClass("swiper_title1");
	                $(".column_slider4_info").addClass("swiper_title1");
	            }
	            if (parseInt($container.css('top')) == -height * 3) {
	                $(".column_slider3_title").addClass("swiper_title1");
	                $(".column_slider3_choice_wrap").addClass("swiper_title1");
	                $(".column_slider_3_Info").addClass("swiper_title1");
	            }
	            if (parseInt($container.css('top')) == -height * 4) {
	                $(".submitInfo").addClass("swiper_title1");
	                $(".submitInfo_left").addClass("swiper_title1");
	            }
	        }
	        if (b == 1) {
	            $('body').on('mousewheel', mouseWheel);
	            $('body').on("DOMMouseScroll", DOMMouseScroll);
	        }
	    });
	    $('.banner li').eq(containerStep).addClass('select').siblings().removeClass('select');
	    if (containerStep == 7) {
	        $('.banner li').eq(0).addClass('select').siblings().removeClass('select');
	    }
	}
	$('.banner li').on('click', function () {
	    $(".swiper_title1").removeClass("swiper_title1");
	    $(".column_slider5_smallImg div").removeClass("column_slider5_smallImg111");
	    $(".column_slider6_ten").removeClass("column_slider6_ten1");
	    $(".img").removeClass("img");
	    containerStep = $('.banner li').index($(this));
	    $container.css({ top: -$('.banner li').index($(this)) * height });
	    $('.banner li').eq(containerStep).addClass('select').siblings().removeClass('select');
	    if (parseInt($container.css('top')) == 0 || parseFloat($container.css('top')) == parseInt(-7 * height)) {
	        $(".swiper_title").addClass("swiper_title1");
	        $(".swiper_more").addClass("swiper_title1");
	        $('.banner').removeClass('banner1');
	        $('.logo').removeClass('logo2').addClass('logo1');
	        // $('.header_nav li a,.header_nav li').css('color','#fff');
	        // $('.header_nav .select').css('borderColor','#fff');
	        $('.reservation').css('color', 'white');
	        $('.arrow').css({ borderRightColor: 'white', borderBottomColor: 'white' });
	        $('.header_nav').removeClass('header_nav1');
	    } else {
	        $('.banner').addClass('banner1');
	        // $('.header_nav li a,.header_nav li').css('color','#2A376E');
	        // $('.header_nav .select').css('borderColor','#2A376E');
	        $('.reservation').css('color', 'white');
	        if (parseInt($container.css('top')) == -height) {
	            // navigate();
	            $(".column_slider5_container_title").addClass("swiper_title1");
	            $(".column_slider5_container_detail").addClass("swiper_title1");
	            $(".column_slider5_smallImg div").addClass("swiper_title1");
	        }
	        if (parseInt($container.css('top')) == -height * 2) {
	            $(".column_slider4_title").addClass("swiper_title1");
	            $(".column_slider4_info").addClass("swiper_title1");
	        }
	        if (parseInt($container.css('top')) == -height * 3) {
	            $(".column_slider3_title").addClass("swiper_title1");
	            $(".column_slider3_choice_wrap").addClass("swiper_title1");
	            $(".column_slider_3_Info").addClass("swiper_title1");
	        }
	        if (parseInt($container.css('top')) == -height * 4) {
	            $(".submitInfo").addClass("swiper_title1");
	            $(".submitInfo_left").addClass("swiper_title1");
	        }
	        // if(parseInt($container.css('top'))==-height*6){
	        // }
	        // if(parseInt($container.css('top'))==-height*5){
	        // }
	    }
	    // move($('.banner li').index($(this)));
	});
	$('.swiper_more').on('click', function () {
	    move();
	});
	$('.bottomArrowBox').on('click', function () {
	    if (containerStep == 4) {
	        return;
	    }
	    move();
	});
	$('.bottomArrow').on('click', function () {
	    if (containerStep == 4) {
	        return;
	    }
	    move();
	});
	
	$('.column_slider3_flower').on('click', function () {
	    $('.column_slider3_flower .select').addClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	
	    $(".column_slider3_flower").addClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_floral').show();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").addClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	});
	$('.column_slider3_floral_lux').on('click', function () {
	    $('.column_slider3_floral_lux .select').addClass('select2');
	    $('.column_slider3_flower .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	
	    $(".column_slider3_floral_lux").addClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_floral_lux').show();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").addClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	});
	$('.column_slider3_suoxin').on('click', function () {
	    $('.column_slider3_flower .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').addClass('select2');
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_sucha').show();
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxin").addClass("selcet_color");
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").addClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	});
	$('.column_slider3_vyluk').on('click', function () {
	    $('.column_slider3_vyluk .select').addClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").addClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').show();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").addClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	});
	$('.column_slider3_suoxingChoice').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').addClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").addClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').show();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").addClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	});
	$('.column_slider3_URBA').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').addClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").addClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').show();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").addClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	});
	$('.column_slider3_BeU').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').addClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").addClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').show();
	
	    $('.column_slider3_Arula .select').removeClass('select2');
	    $(".column_slider3_Arula").removeClass("selcet_color");
	    $('.column_slider_3_Info_Arula').hide();
	    $(".column_slider3_container").removeClass("column_slider3_container_arela");
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").addClass("column_slider3_container_BeU");
	});
	
	$('.column_slider3_Arula').on('click', function () {
	    $('.column_slider3_vyluk .select').removeClass('select2');
	    $('.column_slider3_suoxin .select').removeClass('select2');
	    $('.column_slider3_floral .select').removeClass('select2');
	    $('.column_slider3_floral_lux .select').removeClass('select2');
	    $('.column_slider3_suoxingChoice .select').removeClass('select2');
	    $('.column_slider3_URBA .select').removeClass('select2');
	    $('.column_slider3_BeU .select').removeClass('select2');
	    $('.column_slider3_Arula .select').addClass('select2');
	
	    $(".column_slider3_vyluk").removeClass("selcet_color");
	    $(".column_slider3_suoxin").removeClass("selcet_color");
	    $(".column_slider3_flower").removeClass("selcet_color");
	    $(".column_slider3_floral_lux").removeClass("selcet_color");
	    $(".column_slider3_suoxingChoice").removeClass("selcet_color");
	    $(".column_slider3_URBA").removeClass("selcet_color");
	    $(".column_slider3_BeU").removeClass("selcet_color");
	    $(".column_slider3_Arula").addClass("selcet_color");
	
	    $('.column_slider_3_Info_vyluk').hide();
	    $('.column_slider_3_Info_sucha').hide();
	    $('.column_slider_3_Info_floral').hide();
	    $('.column_slider_3_Info_floral_lux').hide();
	    $('.column_slider_3_Info_suoxingChoice').hide();
	    $('.column_slider_3_Info_URBA').hide();
	    $('.column_slider_3_Info_BeU').hide();
	    $('.column_slider_3_Info_Arula').show();
	
	    $(".column_slider3_container").removeClass("column_slider3_container_vyluk");
	    $(".column_slider3_container").removeClass("column_slider3_container_sucha");
	    $(".column_slider3_container").removeClass("column_slider3_container_floral");
	    $(".column_slider3_container").removeClass("column_slider3_container_suoxingChoice");
	    $(".column_slider3_container").removeClass("column_slider3_container_URBA");
	    $(".column_slider3_container").removeClass("column_slider3_container_BeU");
	    $(".column_slider3_container").addClass("column_slider3_container_arela");
	});
	
	function mouseWheel(e) {
	    if (e.originalEvent.deltaX != 0 && e.originalEvent.deltaX != undefined) {
	        return;
	    }
	    if (e.originalEvent.wheelDelta < 0) {
	        //向下
	        if (containerStep == 4) {
	            return;
	        }
	        $('body').off('mousewheel', mouseWheel);
	        move(undefined, 1);
	    } else if (e.originalEvent.wheelDelta > 0) {
	        //向上
	        if (containerStep == 0) {
	            return;
	        }
	        if (containerStep === 4) {
	            if ($('.column_slider7').scrollTop() !== 0) {
	                return;
	            }
	        }
	        containerStep = containerStep - 2;
	        $('body').off('mousewheel', mouseWheel);
	        move(undefined, 1);
	    }
	}
	function DOMMouseScroll(e) {
	    if (e.originalEvent.detail > 0) {
	        //向下
	        if (containerStep == 4) {
	            return;
	        }
	        $('body').off("DOMMouseScroll", DOMMouseScroll);
	        move(undefined, 1);
	    } else if (e.originalEvent.detail < 0) {
	        //向上
	        if (containerStep == 0) {
	            return;
	        }
	        if (containerStep === 4) {
	            if ($('.column_slider7').scrollTop() !== 0) {
	                return;
	            }
	        }
	        containerStep = containerStep - 2;
	        $('body').off('DOMMouseScroll', DOMMouseScroll);
	        move(undefined, 1);
	    }
	}
	$('body').on('mousewheel', mouseWheel);
	$('body').on("DOMMouseScroll", DOMMouseScroll);
	var smallImgIndex = 0;
	var $ImgBig = $('.column_slider5_container_1 div');
	$('.column_slider5_smallImg div').on('click', function () {
	    var index = $(this).index();
	    smallImgIndex = index;
	    $ImgBig.eq(index).fadeIn(1000).siblings().fadeOut(1000);
	    $(this).find('span').addClass('select');
	    $(this).siblings().find('span').removeClass('select');
	    $('.column_slider5_container_detail').html($(this).find('p').html());
	});
	
	$('.column_slider5_smallImg div').mouseover(function () {
	    $('.column_slider5_smallImg').height(140);
	    $(this).css({ height: '140px', width: '216px' });
	    $('.column_slider5_smallImg div').css({ marginRight: '10px' });
	    $(this).siblings().css({ top: '40px' });
	    $(this).find('span').addClass('select');
	    $(this).siblings().find('span').removeClass('select');
	    $('.column_slider5_smallTea').css({ marginRight: '0' });
	}).mouseout(function () {
	    $('.column_slider5_smallImg').height(100);
	    $(this).css({ height: '100px', width: '166px' });
	    $('.column_slider5_smallImg div').css({ marginRight: '20px' });
	    $(this).siblings().css({ top: 0 });
	    $('.column_slider5_smallTea').css({ marginRight: '0' });
	    $(this).find('span').removeClass('select');
	    $('.column_slider5_smallImg div').eq(smallImgIndex).find('span').addClass('select');
	});
	$('.submitInfo_input_1').on('click', function () {
	    $('.select_forJoinUs').slideToggle();
	});
	$('.select_forJoinUs span').on('click', function () {
	    $('.submitInfo_input_joinUs').html($(this).html());
	});
	$('body').on('click', function (e) {
	    if (e.target.className != "submitInfo_input_joinUs homePageSwiperFiveJoin" && e.target.className != "submitInfo_input submitInfo_input_1") {
	        $('.select_forJoinUs').slideUp();
	    }
	});
	$(".submitInfo_submit").on("click", submitInfo);
	function submitInfo() {
	    if (!$(".submitInfo_name").val()) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputName[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if ($(".submitInfo_name").val().length > 50) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputNameLong[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if ($(".submitInfo_address").val().length > 50) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressLong[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if (!/^1[34578]\d{9}$/.test($(".submitInfo_phone").val())) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if (!$(".submitInfo_address").val()) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressError[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    if (!/^\d+(\.\d+)?$/.test($(".submitInfo_space").val())) {
	        $(".submitInfo_tips_1").html(homePageSwiperFiveInputSpaceError[language]);
	        $(".submitInfo_submit").off("click", submitInfo);
	        $(".submitInfo_tips_1").show();
	        setTimeout(function () {
	            $(".submitInfo_tips_1").hide();
	            $(".submitInfo_submit").on("click", submitInfo);
	        }, 1500);
	        return;
	    }
	    $(".submitInfo_submit").off("click", submitInfo);
	    sensors.track("formSubmit", { "name": $('.submitInfo_name').val(), 'phone_number': $(".submitInfo_phone").val(), 'address': $(".submitInfo_address").val(), 'form_entrance': 'PC首页'
	    });
	    $.ajax({
	        url: url_prefix + '/mng/api/pcms/league/create.json',
	        type: 'POST',
	        data: {
	            name: $(".submitInfo_name").val(),
	            sex: $('input:radio:checked').val() == "boy" ? 1 : 2,
	            mobile: $(".submitInfo_phone").val(),
	            address: $(".submitInfo_address").val(),
	            buildingArea: parseFloat($(".submitInfo_space").val()).toFixed(2) * 10000,
	            intentionType: $(".submitInfo_input_joinUs").html() == homePageSwiperFiveJoin[language] ? 1 : 2,
	            remark: $("textarea").val()
	        },
	        dataType: 'json',
	        timeout: 5000,
	        success: function (res) {
	            if (res.success) {
	                $(".submitInfo_tips_1").html(commonCompanyCubmitSuccess[language]);
	                $(".submitInfo_tips_1").show();
	                $(".submitInfo_name").val("");
	                $(".submitInfo_phone").val("");
	                $(".submitInfo_address").val("");
	                $(".submitInfo_space").val("");
	                $("textarea").val("");
	                $(".submitInfo_input_joinUs").html(homePageSwiperFiveJoin[language]);
	                setTimeout(function () {
	                    $(".submitInfo_tips_1").hide();
	                    $(".submitInfo_submit").on("click", submitInfo);
	                }, 1500);
	            } else {
	                $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
	                $(".submitInfo_tips_1").show();
	                setTimeout(function () {
	                    $(".submitInfo_tips_1").hide();
	                    $(".submitInfo_submit").on("click", submitInfo);
	                }, 1500);
	            }
	        },
	        error: function (error) {
	            $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
	            $(".submitInfo_tips_1").show();
	            setTimeout(function () {
	                $(".submitInfo_tips_1").hide();
	                $(".submitInfo_submit").on("click", submitInfo);
	            }, 1500);
	            $(".submitInfo_submit").on("click", submitInfo);
	        }
	    });
	}
	
	$(".swiper_title").addClass("swiper_title1");
	$(".swiper_more").addClass("swiper_title1");
	
	// function BrowserType()
	// {
	//     var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
	//     var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
	//     var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
	//     var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
	//     var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
	//     var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
	//     var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
	
	//     if (isIE)
	//     {
	//          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
	//          reIE.test(userAgent);
	//          var fIEVersion = parseFloat(RegExp["$1"]);
	//          if(fIEVersion == 7)
	//          { return "IE7";}
	//          else if(fIEVersion == 8)
	//          { return "IE8";}
	//          else if(fIEVersion == 9)
	//          { return "IE9";}
	//          else if(fIEVersion == 10)
	//          { return "IE10";}
	//          else if(fIEVersion == 11)
	//          { return "IE11";}
	//          else
	//          { return "0"}//IE版本过低
	//      }//isIE end
	
	//      if (isFF) {  return "FF";}
	//      if (isOpera) {  return "Opera";}
	//      if (isSafari) {  return "Safari";}
	//      if (isChrome) { return "Chrome";}
	//      if (isEdge) { return "Edge";}
	//  }//myBrowser() end
	
	//  //判断是否是IE浏览器
	//  function isIE()
	//  {
	//     var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
	//     var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
	//     if(isIE)
	//     {
	//         return "1";
	//     }
	//     else
	//     {
	//         return "-1";
	//     }
	//  }
	
	
	//判断是否是IE浏览器，包括Edge浏览器
	function IEVersion() {
	    var isOpera = navigator.userAgent.indexOf("Opera") > -1;
	    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
	    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
	    var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
	    if (isIE) {
	        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
	        reIE.test(userAgent);
	        var fIEVersion = parseFloat(RegExp["$1"]);
	        if (fIEVersion == 7) {
	            return "IE7";
	        } else if (fIEVersion == 8) {
	            return "IE8";
	        } else if (fIEVersion == 9) {
	            return "IE9";
	        } else if (fIEVersion == 10) {
	            return "IE10";
	        } else if (fIEVersion == 11) {
	            return "IE11";
	        } else {
	            return "0";
	        } //IE版本过低
	    } else if (isEdge) {
	        return "Edge";
	    } else {
	        return "-1"; //非IE
	    }
	}
	if (/\d+/.exec(IEVersion())[0] < 10 && /\d+/.exec(IEVersion())[0] > 1) {
	
	    $(".column_slider5_container_title").css({ opacity: 1 });
	    $(".column_slider5_container_detail").css({ opacity: 1 });
	    $(".column_slider5_smallImg div").css({ opacity: 1 });
	    $(".column_slider6_container_title").css({ opacity: 1 });
	    $(".column_slider6_eight").css({ opacity: 1 });
	    $(".column_slider4_title").css({ opacity: 1 });
	    $(".column_slider4_info").css({ opacity: 1 });
	    $(".column_slider2_title").css({ opacity: 1 });
	    $(".column_slider2_introduction").css({ opacity: 1 });
	    $(".submitInfo").css({ opacity: 1 });
	    $(".submitInfo_left").css({ opacity: 1 });
	    $(".column_slider3_title").css({ opacity: 1 });
	    $(".column_slider3_choice_wrap").css({ opacity: 1 });
	    $(".column_slider_3_Info").css({ opacity: 1 });
	    $(".swiper_title").css({ opacity: 1 });
	    $(".swiper_more").css({ opacity: 1 });
	}
	
	function placeholderSupport() {
	    return 'placeholder' in document.createElement('input');
	}
	
	function placeholder(target) {
	
	    $(target).val($(target).attr("datavalue")).addClass("inp");
	    $(target).focus(function () {
	        if ($(this).val() == $(this).attr("datavalue")) {
	            $(this).val("").removeClass("inp");
	        }
	    });
	    $(target).blur(function () {
	        if ($(this).val() == "" || $(this).val() == $(this).attr("datavalue")) {
	            $(this).val($(target).attr("datavalue")).addClass("inp");
	        }
	    });
	}
	
	if (!placeholderSupport()) {
	
	    placeholder(".submitInfo_name");
	    placeholder(".submitInfo_phone");
	    placeholder(".submitInfo_address");
	    placeholder(".submitInfo_space");
	    placeholder(".ipt");
	}
	
	var animateIndex = 0;
	var timer2 = setInterval(function () {
	    animateIndex++;
	    if (animateIndex > 10) {
	        animateIndex = 0;
	    }
	    $(".animate1").eq(animateIndex).addClass("animate2").siblings().removeClass("animate2");
	}, 6000);
	
	$(".animate").on("mouseover", function () {
	    $(".animate1").removeClass("animate2");
	    clearInterval(timer2);
	});
	$(".animate").on("mouseout", function () {
	    $(".animate1").eq(animateIndex).addClass("animate2");
	    timer2 = setInterval(function () {
	        animateIndex++;
	        if (animateIndex > 10) {
	            animateIndex = 0;
	        }
	        $(".animate1").eq(animateIndex).addClass("animate2").siblings().removeClass("animate2");
	    }, 6000);
	});

/***/ },

/***/ 215:
/***/ function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	if (window.location.search.indexOf('lang=En') > -1) {
	    language = 'USA';
	    localStorage.setItem('language', 'USA');
	}
	
	$('.commonlanguage').html(commonlanguage[language]);
	$('.commonHomePage').html(commonHomePage[language]);
	$('.commonLvyue').html(commonLvyue[language]);
	$('.commonAboutLvyue').html(commonAboutLvyue[language]);
	$('.commonflowerTravel').html(commonflowerTravel[language]);
	$('.commonlvyueBrand').html(commonlvyueBrand[language]);
	$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
	$('.commonFloralLux').html(commonFloralLux[language]);
	$('.commonClaim').html(commonClaim[language]);
	$('.commonClaimChoice').html(commonClaimChoice[language]);
	$('.commonWeiLai').html(commonWeiLai[language]);
	$('.commonTanChen').html(commonTanChen[language]);
	$('.commonBanlan').html(commonBanlan[language]);
	$('.commonBaina').html(commonBaina[language]);
	$('.commonArulas').html(commonArulas[language]);
	
	$('.homePageSwiperFourDesignideaInfo7').html(homePageSwiperFourDesignideaInfo7[language]);
	$('.homePageSwiperFourBrandintroductionInof7').html(homePageSwiperFourBrandintroductionInof7[language]);
	$('.homePageSwiperFourMotto7').html(homePageSwiperFourMotto7[language]);
	
	$('.commonBeu').html(commonBeu[language]);
	$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
	$('.commonPanorama').html(commonPanorama[language]);
	// $('.commonPaidInformation').html(commonPaidInformation[language]);
	$('.commonZh').html(commonZh[language]);
	$('.commonUsa').html(commonUsa[language]);
	$('.commonJp').html(commonJp[language]);
	$('.commonKo').html(commonKo[language]);
	$('.commonTh').html(commonTh[language]);
	$('.commonYh').html(commonYh[language]);
	
	$('.subhtml').html(subhtml[language]);
	$('.commonReservations a').html(commonReservations[language]);
	$('.commonClose').html(commonClose[language]);
	$('.commonFreebooking').html(commonFreebooking[language]);
	$('.commonDownload').html(commonDownload[language]);
	$('.commonWechatSubscription').html(commonWechatSubscription[language]);
	$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
	$('.commonBrandintroductio').html(commonBrandintroductio[language]);
	$('.commonWantJoin').html(commonWantJoin[language]);
	$('.commonConectUs').html(commonConectUs[language]);
	$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
	$('.commonCustomerServiceHotline_china').html(commonCustomerServiceHotline_china[language]);
	$('.commonCustomerServiceHotline_japan').html(commonCustomerServiceHotline_japan[language]);
	$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
	$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
	$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
	$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
	$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
	$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
	$('.commonCompanyInfo').html(commonCompanyInfo[language]);
	$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
	$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
	$('.commonCompanyLicense').html(commonCompanyLicense[language]);
	$('.commonCompanyICP').html(commonCompanyICP[language]);
	$('.homePageSwiperOneTitle').html(homePageSwiperOneTitle[language]);
	$('.homePageSwiperTwoTitle').html(homePageSwiperTwoTitle[language]);
	$('.homePageSwiperThreeTitle').html(homePageSwiperThreeTitle[language]);
	$('.homePageSwiperThreeInfo').html(homePageSwiperThreeInfo[language]);
	$('.homePageSwiperThreeOpenedArea').html(homePageSwiperThreeOpenedArea[language]);
	$('.homePageSwiperTobeOpenedArea').html(homePageSwiperTobeOpenedArea[language]);
	$('.homePageSwiperThreeKohSamui').html(homePageSwiperThreeKohSamui[language]);
	$('.homePageSwiperThreeBeijing').html(homePageSwiperThreeBeijing[language]);
	$('.homePageSwiperThreeNanjing').html(homePageSwiperThreeNanjing[language]);
	$('.homePageSwiperThreeMoganmountain').html(homePageSwiperThreeMoganmountain[language]);
	$('.homePageSwiperThreeNanxun').html(homePageSwiperThreeNanxun[language]);
	$('.homePageSwiperThreeAnji').html(homePageSwiperThreeAnji[language]);
	$('.homePageSwiperThreeChiangmai').html(homePageSwiperThreeChiangmai[language]);
	$('.homePageSwiperThreeSeoul').html(homePageSwiperThreeSeoul[language]);
	$('.homePageSwiperThreeXishuangbanna').html(homePageSwiperThreeXishuangbanna[language]);
	$('.homePageSwiperThreeDali').html(homePageSwiperThreeDali[language]);
	$('.homePageSwiperThreeLijiang').html(homePageSwiperThreeLijiang[language]);
	$('.homePageSwiperThreeChongqie').html(homePageSwiperThreeChongqie[language]);
	$('.homePageSwiperThreeLangzhonge').html(homePageSwiperThreeLangzhonge[language]);
	$('.homePageSwiperThreeGuohuang').html(homePageSwiperThreeGuohuang[language]);
	$('.homePageSwiperThreeLibo').html(homePageSwiperThreeLibo[language]);
	$('.homePageSwiperThreeZhangjiajie').html(homePageSwiperThreeZhangjiajie[language]);
	$('.homePageSwiperThreeHuangshan').html(homePageSwiperThreeHuangshan[language]);
	$('.homePageSwiperThreeHangzhou').html(homePageSwiperThreeHangzhou[language]);
	$('.homePageSwiperThreeChejudo').html(homePageSwiperThreeChejudo[language]);
	$('.homePageSwiperThreeFenghuang').html(homePageSwiperThreeFenghuang[language]);
	$('.homePageSwiperThreeSemporna').html(homePageSwiperThreeSemporna[language]);
	$('.homePageSwiperThreeWuzhen').html(homePageSwiperThreeWuzhen[language]);
	$('.homePageSwiperThreeSuzhou').html(homePageSwiperThreeSuzhou[language]);
	$('.homePageSwiperThreeGuilin').html(homePageSwiperThreeGuilin[language]);
	$('.homePageSwiperThreeWulong').html(homePageSwiperThreeWulong[language]);
	$('.homePageSwiperThreeXian').html(homePageSwiperThreeXian[language]);
	$('.homePageSwiperThreePingyao').html(homePageSwiperThreePingyao[language]);
	$('.homePageSwiperThreeXiamen').html(homePageSwiperThreeXiamen[language]);
	$('.homePageSwiperThreeLishui').html(homePageSwiperThreeLishui[language]);
	$('.homePageSwiperThreeXitang').html(homePageSwiperThreeXitang[language]);
	$('.homePageSwiperThreeSingapore').html(homePageSwiperThreeSingapore[language]);
	$('.homePageSwiperThreeKualaLumpur').html(homePageSwiperThreeKualaLumpur[language]);
	$('homePageSwiperThreePenang').html(homePageSwiperThreePenang[language]);
	$('.homePageSwiperThreePhuket').html(homePageSwiperThreePhuket[language]);
	$('.homePageSwiperThreeLangkawi').html(homePageSwiperThreeLangkawi[language]);
	$('.homePageSwiperThreePhnomPenh').html(homePageSwiperThreePhnomPenh[language]);
	$('.homePageSwiperThreeKotaKinabalu').html(homePageSwiperThreeKotaKinabalu[language]);
	$('.homePageSwiperThreePattaya').html(homePageSwiperThreePattaya[language]);
	$('.homePageSwiperThreeBangkok').html(homePageSwiperThreeBangkok[language]);
	$('.homePageSwiperThreeSiemReap').html(homePageSwiperThreeSiemReap[language]);
	$('.homePageSwiperThreeNhaTrang').html(homePageSwiperThreeNhaTrang[language]);
	$('.homePageSwiperThreeDaNang').html(homePageSwiperThreeDaNang[language]);
	$('.homePageSwiperThreeCebu').html(homePageSwiperThreeCebu[language]);
	$('.homePageSwiperThreeBoracayIsland').html(homePageSwiperThreeBoracayIsland[language]);
	$('.homePageSwiperThreeManila').html(homePageSwiperThreeManila[language]);
	$('.homePageSwiperThreeHanoi').html(homePageSwiperThreeHanoi[language]);
	$('.homePageSwiperThreeHongKong').html(homePageSwiperThreeHongKong[language]);
	$('.homePageSwiperThreeKaohsiung').html(homePageSwiperThreeKaohsiung[language]);
	$('.homePageSwiperThreeHualian').html(homePageSwiperThreeHualian[language]);
	$('.homePageSwiperThreeTaipei').html(homePageSwiperThreeTaipei[language]);
	$('.homePageSwiperThreeTengchong').html(homePageSwiperThreeTengchong[language]);
	$('.homePageSwiperThreeShangriLa').html(homePageSwiperThreeShangriLa[language]);
	$('.homePageSwiperThreeWuyiMount').html(homePageSwiperThreeWuyiMount[language]);
	$('.homePageSwiperThreeJiaxing').html(homePageSwiperThreeJiaxing[language]);
	$('.homePageSwiperThreeRizhao').html(homePageSwiperThreeRizhao[language]);
	$('.homePageSwiperThreeBusan').html(homePageSwiperThreeBusan[language]);
	$('.homePageSwiperThreeRizhao').html(homePageSwiperThreeRizhao[language]);
	$('.homePageSwiperThreeOsaka').html(homePageSwiperThreeOsaka[language]);
	$('.homePageSwiperThreeTokyo').html(homePageSwiperThreeTokyo[language]);
	$('.homePageSwiperThreekyoto').html(homePageSwiperThreekyoto[language]);
	$('.homePageSwiperThreeXinzhou').html(homePageSwiperThreeXinzhou[language]);
	$('.homePageSwiperFourTitle').html(homePageSwiperFourTitle[language]);
	$('.homePageSwiperFourBrandintroduction').html(homePageSwiperFourBrandintroduction[language]);
	$('.homePageSwiperBrandintroductionInof1').html(homePageSwiperBrandintroductionInof1[language]);
	$('.homePageSwiperBrandintroductionInof10').html(homePageSwiperBrandintroductionInof10[language]);
	$('.homePageSwiperFourDesignidea').html(homePageSwiperFourDesignidea[language]);
	$('.homePageSwiperFourDesignideaInfo1').html(homePageSwiperFourDesignideaInfo1[language]);
	$('.homePageSwiperFourSite').html(homePageSwiperFourSite[language]);
	$('.homePageSwiperFourView').html(homePageSwiperFourView[language]);
	$('.homePageSwiperFourVacation').html(homePageSwiperFourVacation[language]);
	$('.homePageSwiperFourBusinesstrip').html(homePageSwiperFourBusinesstrip[language]);
	$('.homePageSwiperFourBrandintroductionInof3').html(homePageSwiperFourBrandintroductionInof3[language]);
	$('.homePageSwiperFourDesignideaInfo3').html(homePageSwiperFourDesignideaInfo3[language]);
	$('.homePageSwiperFourBusinesstrip').html(homePageSwiperFourBusinesstrip[language]);
	$('.homePageSwiperFourBrandintroductionInof2').html(homePageSwiperFourBrandintroductionInof2[language]);
	$('.homePageSwiperFourDesignideaInfo2').html(homePageSwiperFourDesignideaInfo2[language]);
	$('.homePageSwiperFourTourismVacationSocialBusiness').html(homePageSwiperFourTourismVacationSocialBusiness[language]);
	
	$('.homePageSwiperFourBrandintroductionInof4').html(homePageSwiperFourBrandintroductionInof4[language]);
	$('.homePageSwiperFourDesignideaInfo4').html(homePageSwiperFourDesignideaInfo4[language]);
	$('.homePageSwiperFourMotto4').html(homePageSwiperFourMotto4[language]);
	$('.homePageSwiperFourBrandintroductionInof5').html(homePageSwiperFourBrandintroductionInof5[language]);
	$('.homePageSwiperFourDesignideaInfo5').html(homePageSwiperFourDesignideaInfo5[language]);
	$('.homePageSwiperFourMotto5').html(homePageSwiperFourMotto5[language]);
	$('.homePageSwiperFourBrandintroductionInof6').html(homePageSwiperFourBrandintroductionInof6[language]);
	$('.homePageSwiperFourDesignideaInfo6').html(homePageSwiperFourDesignideaInfo6[language]);
	$('.homePageSwiperFourMotto6').html(homePageSwiperFourMotto6[language]);
	
	$('.homePageSwiperFiveJointheInformation').html(homePageSwiperFiveJointheInformation[language]);
	$('.homePageSwiperFiveJointheInformation').attr('placeholder', homePageSwiperFiveJointheInformation[language]);
	$('.homePageSwiperFiveGirl').html(homePageSwiperFiveGirl[language]);
	$('.homePageSwiperFiveBoy').html(homePageSwiperFiveBoy[language]);
	$('.homePageSwiperFiveInputPhone').attr('placeholder', homePageSwiperFiveInputPhone[language]);
	$('.homePageSwiperFiveInputPhone').attr('datavalue', homePageSwiperFiveInputPhone[language]);
	$('.homePageSwiperFiveInputAddress').attr('placeholder', homePageSwiperFiveInputAddress[language]);
	$('.homePageSwiperFiveInputAddress').attr('datavalue', homePageSwiperFiveInputAddress[language]);
	$('.homePageSwiperFiveInputSpace').attr('placeholder', homePageSwiperFiveInputSpace[language]);
	$('.homePageSwiperFiveInputSpace').attr('datavalue', homePageSwiperFiveInputSpace[language]);
	$('.homePageSwiperFiveJoin').html(homePageSwiperFiveJoin[language]);
	$('.homePageSwiperFiveMaterialcooperation').html(homePageSwiperFiveMaterialcooperation[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('placeholder', homePageSwiperFiveJoinRemarkTips[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue', homePageSwiperFiveJoinRemarkTips[language]);
	$('.homePageSwiperFiveInputName').attr('placeholder', homePageSwiperFiveInputName[language]);
	$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue', homePageSwiperFiveInputName[language]);
	$('.homePageSwiperFiveInputName').html(homePageSwiperFiveInputName[language]);
	$('.homePageSwiperFiveJoinLvyue').html(homePageSwiperFiveJoinLvyue[language]);
	$('.homePageSwiperFiveJoinInfo').html(homePageSwiperFiveJoinInfo[language]);
	$('.homePageSwiperThreePenang').html(homePageSwiperThreePenang[language]);
	$('.commonLvyue1').html(commonLvyue1[language]);
	$('.Leadership').html(Leadership[language]);
	$('.TalentRecruitment').html(TalentRecruitment[language]);
	$('.floralReservation').html(floralReservation[language]);
	$('.commonBaina').html(commonBaina[language]);

/***/ },

/***/ 237:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

});


/** WEBPACK FOOTER **
 ** js/indexForeign.94cf8b3f.js
 **/